import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import "./About.css";

import HeroSection from "./HeroSection";


const WhyWingloLive = lazy(() => import("./WhyWingloLive"));
const VisionMission = lazy(() => import("./VisionMission"));
const CoreStrengthsSection = lazy(() => import("./CoreStrengthsSection"));
const CompetitiveAdvantagesSection = lazy(() => import("./CompetitiveAdvantagesSection"));
const ExperienceExpertise = lazy(() => import("./ExperienceExpertise"));

const About = () => {
  return (
    <>
      <Helmet>
        <title>
          About Winglo | Enterprise LIMS & Healthcare Technology Solutions
        </title>

        <meta
          name="description"
          content="Learn about Winglo, a Chennai-based cloud technology company delivering enterprise-grade Laboratory Information Management Systems (LIMS) and healthcare software solutions designed for scalability, accuracy, and operational excellence."
        />

        <meta
          name="keywords"
          content="About Winglo, Winglo Solution Pvt Ltd, healthcare technology company, LIMS provider India, laboratory software company Chennai, enterprise lab management system, healthcare IT solutions"
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[300px]" aria-busy="true" />}>
        <WhyWingloLive />
        <VisionMission />
        <CoreStrengthsSection />
        <CompetitiveAdvantagesSection />
        <ExperienceExpertise />
      </Suspense>
    </>
  );
};

export default About;
